import { URI_MESSAGES_SERVICE } from '@/config/config';
export default async (bearerToken, userToken) => {
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
    },
  };
  const response = await fetch(
    `${URI_MESSAGES_SERVICE}messages/${userToken}`,
    opts,
  );
  const jsonResult = await response.json();
  if (response.status >= 400) {
    throw new Error(jsonResult);
  }

  const messages = jsonResult.data.reverse();
  return messages;
};
